export interface ReconciliationLineItem {
  id: string;
  skuName: string;
  skuId: string;
  lotId: string;
  lotName: string;
  expiryDate: string;
  systemOnHandQty: number;
  physicalOnHandQty?: number;
  isManuallyAdded?: boolean;
  productName: string;
  productId: string;
}

export interface ProductSourceItem {
  id: string;
  title: string;
  image: string;
  refObject: {
    skuId: string;
    skuName: string;
    productId: string;
    productName: string;
    lotId: string;
    lotName: string;
    expiryDate: string;
    systemOnHandQty: number;
  };
  endIcon?: string;
  hideAvatarOrInitial: boolean;
}

export interface LotWithZeroQty {
  skuId: string;
  skuName: string;
  productId: string;
  productName: string;
  lotId: string;
  lotName: string;
  expiryDate: string;
  systemOnHandQty: number;
}

export interface SelectedProductItem {
  id: string;
  title: string;
  image: string;
  refObject: {
    skuId: string;
    skuName: string;
    productId: string;
    productName: string;
    lotId: string;
    lotName: string;
  };
  endIcon: string;
  hideAvatarOrInitial: boolean;
}

export interface ReconciliationRequest {
  id?: string;
  indskr_name?: string;
  indskr_type?: number;
  indskr_submitteddate?: string;
  indskr_user?: string;
  indskr_purpose?: string;
  _indskr_purpose_value?: string;
  _indskr_purpose_value_formatted?: string;
  indskr_samplerequestid?: string;
  [key: string]: unknown;
}

export interface ReconciliationLineItemResponse {
  indskr_samplereconciliationid?: string;
  indskr_systemonhandqty?: number;
  indskr_physicalonhandqty?: number;
  'sku.name'?: string;
  '_indskr_sku_value@OData.Community.Display.V1.FormattedValue'?: string;
  'lot.name'?: string;
  '_indskr_lot_value@OData.Community.Display.V1.FormattedValue'?: string;
  'sku.productid'?: string;
  'lot.productid'?: string;
  'prod.name'?: string;
  'prod.productid'?: string;
  'lot.validtodate'?: string;
  [key: string]: unknown;
}

export interface ReconciliationCreateResponse {
  indskr_samplerequestid?: string;
  [key: string]: unknown;
}

export interface ProductComponentEventData {
  isDone?: boolean;
  selectedItems?: Array<{ id: string; [key: string]: unknown }>;
  removedItems?: Array<{ id: string; [key: string]: unknown }>;
  [key: string]: unknown;
}

// Type guard to check if object is SampleReconciliation
export function isSampleReconciliation(obj: SampleReconciliation | ReconciliationRequest | null): obj is SampleReconciliation {
  return obj !== null && obj !== undefined && 'name' in obj && typeof (obj as SampleReconciliation).name === 'string';
}

// Helper to get reconciliation name
export function getReconciliationName(request: SampleReconciliation | ReconciliationRequest | null): string {
  if (!request) return '';
  if (isSampleReconciliation(request)) {
    return request.name;
  }
  return (request as ReconciliationRequest).indskr_name || '';
}

export class SampleReconciliation {
  id: string;
  name: string;
  type: number;
  typeFormatted: string;
  submittedDate: Date;
  submittedDateFormatted: string;
  userId: string;
  userName: string;
  stateCode: number;
  stateCodeFormatted: string;
  statusCode: number;
  statusCodeFormatted: string;
  createdOn: Date;
  createdOnFormatted: string;
  modifiedOn: Date;
  modifiedOnFormatted: string;
  createdById: string;
  createdByName: string;
  modifiedById: string;
  modifiedByName: string;
  ownerId: string;
  ownerName: string;
  owningBusinessUnitId: string;
  owningBusinessUnitName: string;
  etag: string;
  isSelected: boolean = false;
  _indskr_purpose_value : string;
  _indskr_purpose_value_formatted : string;
  constructor(raw: any) {
    this.id = raw.indskr_samplerequestid || raw.id;
    this.name = raw.indskr_name || '';
    this.type = raw.indskr_type;
    this.userId = raw._indskr_user_value || raw.indskr_user;
    this.stateCode = raw.statecode;
    this.statusCode = raw.statuscode;
    this.createdOn = raw.createdon ? new Date(raw.createdon) : null;
    this.modifiedOn = raw.modifiedon ? new Date(raw.modifiedon) : null;
    this.submittedDate = raw.indskr_submitteddate ? new Date(raw.indskr_submitteddate) : null;
    this._indskr_purpose_value = raw._indskr_purpose_value;
    this._indskr_purpose_value_formatted = raw['_indskr_purpose_value@OData.Community.Display.V1.FormattedValue'] || raw._indskr_purpose_value_formatted
    ;
  }

  public get DTO(): any {
    return {
      indskr_name: this.name,
      indskr_type: this.type,
      indskr_submitteddate: this.submittedDate ? this.submittedDate.toISOString() : null,
      _indskr_user_value: this.userId,
      statecode: this.stateCode,
      statuscode: this.statusCode,
      _ownerid_value: this.ownerId,
    };
  }
}
